export default class AdsSlideshowModel {
  cssClasses: string;
  controlsCssClasses: string;
  progressCssClasses: string;
  style: string;
}